/**
 * @file The refusal `parseAnalyticsBindings` throws when the `parameters/analyticsBindings` document
 * is malformed as a whole, rather than one of its role bindings: the fact build fails before writing
 * anything, so the previous tables stay readable. `key` is the offending key, such as `roles`,
 * `valueBundleRole` or `roles.<key>`, or the document path when the document itself is not an
 * object. Neither the key nor the message ever carries a stored value.
 */
export class AnalyticsBindingsMalformed extends Error {
    constructor(readonly key: string) {
        super(`Analytics bindings are malformed at ${key}`);
        this.name = 'AnalyticsBindingsMalformed';
    }
}
